import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { locationBinderInterface } from "../../../app/shared/component/location-binder/location-binder.interface";

import { VisitorService } from "../../../app/visitor/service/api/visitor.service";
import { TodaysBirthdayService } from "../service/api/todays-birthday.service";
import { todaysEventInterface } from "../service/todays-event.interface";

@Component({
  selector: "app-birthday-create",
  templateUrl: "./birthday-create.component.html",
  styleUrls: ["./birthday-create.component.scss"],
})
export class BirthdayCreateComponent implements OnInit {
  todaysEventObj: todaysEventInterface;
  locationBinderObj: locationBinderInterface;
  maximunDate = new Date();
  currentYear = this.maximunDate.getFullYear();
  yearRange = `${this.currentYear - 80}:${this.currentYear}`;

  constructor(
    private visitorService: VisitorService,
    private router: Router,
    private todayBirthdayService: TodaysBirthdayService
  ) {
    this.todaysEventObj = {};
    this.locationBinderObj = {};
  }

  saveBirthdayData(data) {
    if (data.valid) {
      this.todaysEventObj = Object.assign(
        this.todaysEventObj,
        this.locationBinderObj
      );
      // this.visitorService
      //   .createVisitorData(this.todaysEventObj)
      //   .subscribe((res: any) => {
      //   });
      this.todayBirthdayService.addBirthday(this.todaysEventObj).subscribe(
        (res: any) => {
          this.router.navigate(["/todays-birthday/list"]);
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }
  ngOnInit() {}
}
